import { render, staticRenderFns } from "./GeoGuesserQuestion.vue?vue&type=template&id=edf21cb4&scoped=true&"
import script from "./GeoGuesserQuestion.vue?vue&type=script&lang=js&"
export * from "./GeoGuesserQuestion.vue?vue&type=script&lang=js&"
import style0 from "./GeoGuesserQuestion.vue?vue&type=style&index=0&id=edf21cb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf21cb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VRow})
